import {
  METRIC_CATEGORY_LABELS,
  METRIC_CATEGORY_ORDER,
  MetricCategory,
} from '@chiroup/core/constants/metricCategories';
import {
  BookOpen,
  Building2,
  CalendarDays,
  ClipboardList,
  Database,
  DollarSign,
  UserCog,
  Users,
} from 'lucide-react';
import React from 'react';

type Props = {
  active: MetricCategory;
  onChange: (next: MetricCategory) => void;
  categoryTotals: Record<MetricCategory, number>;
};

const CATEGORY_ICONS: Record<MetricCategory, React.ElementType> = {
  schedule: CalendarDays,
  clinical: ClipboardList,
  billing: DollarSign,
  patients: Users,
  databases: Database,
  clinic_settings: Building2,
  user_settings: UserCog,
  resources: BookOpen,
};

const CategoryTabs: React.FC<Props> = ({ active, onChange, categoryTotals }) => {
  return (
    <div className="border-b border-gray-200 overflow-x-auto">
      <nav className="flex gap-1 min-w-max">
        {METRIC_CATEGORY_ORDER.map(cat => {
          const isActive = cat === active;
          const total = categoryTotals[cat] ?? 0;
          const Icon = CATEGORY_ICONS[cat];

          return (
            <button
              key={cat}
              type="button"
              onClick={() => onChange(cat)}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px flex items-center gap-2 transition ${
                isActive
                  ? 'border-primary-500 text-primary-600'
                  : 'border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-200'
              }`}
            >
              <Icon className={`h-4 w-4 ${isActive ? 'text-primary-500' : 'text-gray-400'}`} />
              <span>{METRIC_CATEGORY_LABELS[cat]}</span>
              <span
                className={`text-xs rounded-full px-1.5 py-0.5 tabular-nums ${
                  isActive ? 'bg-primary-100 text-primary-700' : 'bg-gray-100 text-gray-500'
                }`}
              >
                {total.toLocaleString()}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default CategoryTabs;
